/**
 * Bridge for the per-install distribution marker (read-only).
 *
 * Wraps the main-app Tauri command `get_distribution_tag`
 * (src-tauri/src/ipc/distribution_tag.rs), which reads a marker file under the
 * app-data dir. The marker is *written* by Rust on startup (not the webview —
 * see DICTATE-BUNDLE.md §1b), so there is no setter here. Plain `Result`
 * command, so it uses raw `invoke` rather than the JSON-RPC `ipc_invoke`
 * envelope (same shape as `src/tauri/chronicle/auto-session.ts`: isTauri guard
 * + try/catch + logger + swallow-to-null).
 *
 * No-op off-desktop. A read error is swallowed and reported as "absent" so it
 * never blocks launch. Caveat: for an install already stamped `dictate` that
 * has auto-updated to a regular build, a *transient* read failure is
 * indistinguishable from "never stamped" and momentarily drops the user into
 * the regular sign-in flow — self-heals on the next launch (the marker is still
 * on disk and a regular build never erases it). See DICTATE-BUNDLE.md.
 */
import { isTauri } from '@/tauri/utils';
import { logger } from '@/utils/logger/logger';
import { invoke } from '@tauri-apps/api/core';

export async function getDistributionTag(): Promise<string | null> {
  if (!isTauri()) return null;
  try {
    return (await invoke<string | null>('get_distribution_tag')) ?? null;
  } catch (error) {
    logger.error('[distributionTag] get failed', (error as Error)?.message);
    return null;
  }
}
